import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c20cfc40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import "./index.vue?vue&type=style&index=0&id=c20cfc40&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20cfc40",
  null
  
)

export default component.exports